<template>
  <div class="flex-grow flex-shrink min-w-0 p-6 overflow-auto">
    <form
      v-if="!uiFlags.isFetchingItem && hasReadPermission('Account settings')"
      @submit.prevent="updateAccount"
    >
      <div
        class="flex flex-row p-4 border-b border-slate-25 dark:border-slate-800"
      >
        <div
          class="flex-grow-0 flex-shrink-0 flex-[25%] min-w-0 py-4 pr-6 pl-0"
        >
          <h4 class="block-title text-black-900 dark:text-slate-200">
            {{ $t('GENERAL_SETTINGS.FORM.GENERAL_SECTION.TITLE') }}
          </h4>
          <p>{{ $t('GENERAL_SETTINGS.FORM.GENERAL_SECTION.NOTE') }}</p>
        </div>
        <div class="p-4 flex-grow-0 flex-shrink-0 flex-[50%]">
          <image-uploader
            v-if="showLogo"
            :label="$t('GENERAL_SETTINGS.FORM.LOGO.LABEL')"
            :src="logoUrl"
            delete-image
            :delete-title="$t('GENERAL_SETTINGS.FORM.LOGO.DELETE_BTN_TEXT')"
            @change="handleImageUpload"
            @onDelete="handleImageDelete"
          />
          <label :class="{ error: $v.name.$error }">
            <div @dblclick="showLogo = true">
              {{ $t('GENERAL_SETTINGS.FORM.NAME.LABEL') }}
            </div>
            <input
              v-model="name"
              type="text"
              disabled
              :placeholder="$t('GENERAL_SETTINGS.FORM.NAME.PLACEHOLDER')"
              @blur="$v.name.$touch"
            />
            <span v-if="$v.name.$error" class="message">
              {{ $t('GENERAL_SETTINGS.FORM.NAME.ERROR') }}
            </span>
          </label>

          <!--          <label :class="{ error: $v.chatview.$error }">-->
          <!--            {{ $t('GENERAL_SETTINGS.FORM.CHATVIEW.LABEL') }}-->
          <!--            <select v-model="chatview">-->
          <!--              <option-->
          <!--                v-for="chatStatus in chatViewArray"-->
          <!--                :key="chatStatus.key"-->
          <!--                :value="chatStatus.value"-->
          <!--              >-->
          <!--                {{ chatStatus.name }}-->
          <!--              </option>-->
          <!--            </select>-->
          <!--            <span v-if="$v.chatview.$error" class="message">-->
          <!--              {{ $t('GENERAL_SETTINGS.FORM.CHATVIEW.ERROR') }}-->
          <!--            </span>-->
          <!--          </label>-->

          <label v-if="featureCustomReplyDomainEnabled">
            {{
              $t('GENERAL_SETTINGS.FORM.FEATURES.CUSTOM_EMAIL_DOMAIN_ENABLED')
            }}
          </label>
          <label v-if="featureCustomReplyDomainEnabled">
            {{ $t('GENERAL_SETTINGS.FORM.DOMAIN.LABEL') }}
            <input
              v-model="domain"
              type="text"
              :placeholder="$t('GENERAL_SETTINGS.FORM.DOMAIN.PLACEHOLDER')"
            />
          </label>
          <label
            v-if="
              featureCustomReplyEmailEnabled &&
              online99PlatformsCanSeeSupportEmail
            "
          >
            {{ $t('GENERAL_SETTINGS.FORM.SUPPORT_EMAIL.LABEL') }}
            <input
              v-model="supportEmail"
              type="text"
              :placeholder="
                $t('GENERAL_SETTINGS.FORM.SUPPORT_EMAIL.PLACEHOLDER')
              "
            />
          </label>
          <label
            v-if="showAutoResolutionConfig"
            :class="{ error: $v.autoResolveDuration.$error }"
          >
            {{ $t('GENERAL_SETTINGS.FORM.AUTO_RESOLVE_DURATION.LABEL') }}
            <input
              v-model="autoResolveDuration"
              type="number"
              :placeholder="
                $t('GENERAL_SETTINGS.FORM.AUTO_RESOLVE_DURATION.PLACEHOLDER')
              "
              @blur="$v.autoResolveDuration.$touch"
            />
            <span v-if="$v.autoResolveDuration.$error" class="message">
              {{ $t('GENERAL_SETTINGS.FORM.AUTO_RESOLVE_DURATION.ERROR') }}
            </span>
          </label>
        </div>
      </div>

      <div
        class="p-4 border-slate-25 dark:border-slate-700 text-black-900 dark:text-slate-300 row"
      >
        <div
          class="flex-grow-0 flex-shrink-0 flex-[25%] min-w-0 py-4 pr-6 pl-0"
        >
          <h4 class="block-title text-black-900 dark:text-slate-200">
            {{ $t('GENERAL_SETTINGS.FORM.ACCOUNT_ID.TITLE') }}
          </h4>
          <p>
            {{ $t('GENERAL_SETTINGS.FORM.ACCOUNT_ID.NOTE') }}
          </p>
        </div>
        <div class="p-4 flex-grow-0 flex-shrink-0 flex-[50%]">
          <woot-code :script="getAccountId" />
        </div>
      </div>

      <!--            d99d-->
      <div
        v-if="online99PlatformsCanSeeAllowedIps"
        class="p-4 border-slate-25 dark:border-slate-700 text-black-900 dark:text-slate-300 row"
      >
        <div
          class="flex-grow-0 flex-shrink-0 flex-[25%] min-w-0 py-4 pr-6 pl-0"
        >
          <h4 class="block-title text-black-900 dark:text-slate-200">
            {{ $t('GENERAL_SETTINGS.FORM.ALLOWED_IPS.TITLE') }}
          </h4>
          <p>
            {{ $t('GENERAL_SETTINGS.FORM.ALLOWED_IPS.NOTE') }}
          </p>
        </div>
        <div class="py-4 pl-4 pr-1 flex-grow-0 flex-shrink-0 flex-[50%]">
          <div v-for="(_, index) in allowedIps" :key="index" class="flex">
            <input
              :id="'allowedIps-' + index"
              v-model="allowedIps[index]"
              type="text"
              :placeholder="
                $t('GENERAL_SETTINGS.FORM.ALLOWED_IPS.PLACEHOLDER', {
                  index: index + 1,
                })
              "
            />
            <div class="w-3">
              <woot-button
                v-show="index > 0"
                icon="dismiss"
                variant="clear"
                color-scheme="secondary"
                @click.prevent="removeAllowedIp(index)"
              />
            </div>
          </div>

          <woot-button
            v-if="isAddAllowedIpAvailable"
            icon="add"
            color-scheme="success"
            variant="smooth"
            size="small"
            @click.prevent="addAllowedIp"
          >
            {{ $t('GENERAL_SETTINGS.FORM.ALLOWED_IPS.ADD_BUTTON_LABEL') }}
          </woot-button>
          <div v-if="$v.allowedIps.$error" class="error">
            {{ $t('GENERAL_SETTINGS.FORM.ALLOWED_IPS.ERROR') }}
          </div>
        </div>
      </div>
      <!--      Concurrent users      -->
      <div
        v-if="showConcurrentUsersConfig"
        class="p-4 border-slate-25 dark:border-slate-700 text-black-900 dark:text-slate-300 row"
      >
        <div
          class="flex-grow-0 flex-shrink-0 flex-[25%] min-w-0 py-4 pr-6 pl-0"
        >
          <h4 class="block-title text-black-900 dark:text-slate-200">
            {{ $t('GENERAL_SETTINGS.FORM.CONCURRENT_USERS.TITLE') }}
          </h4>
          <p>
            {{ $t('GENERAL_SETTINGS.FORM.CONCURRENT_USERS.NOTE') }}
          </p>
        </div>
        <div class="p-4 flex-grow-0 flex-shrink-0 flex-[50%]">
          <label :class="{ error: $v.concurrentUsersLimit.$error }">
            {{ $t('GENERAL_SETTINGS.FORM.CONCURRENT_USERS.LABEL') }}
            <span
              v-if="concurrentUsersActive !== null"
              class="live-count"
              :title="$t('GENERAL_SETTINGS.FORM.CONCURRENT_USERS.LIVE_TOOLTIP')"
            >
              <span class="live-count__dot" />
              {{
                $t('GENERAL_SETTINGS.FORM.CONCURRENT_USERS.LIVE', {
                  count: concurrentUsersActive,
                })
              }}
            </span>
            <input
              v-model="concurrentUsersLimit"
              type="number"
              min="1"
              step="1"
              required
              :disabled="!canEditConcurrentUsersLimit"
              :placeholder="
                $t('GENERAL_SETTINGS.FORM.CONCURRENT_USERS.PLACEHOLDER')
              "
              @blur="$v.concurrentUsersLimit.$touch"
            />
            <span v-if="$v.concurrentUsersLimit.$error" class="message">
              {{ $t('GENERAL_SETTINGS.FORM.CONCURRENT_USERS.ERROR') }}
            </span>
          </label>
        </div>
      </div>
      <!--      External link warning      .-->
      <div
        class="p-4 border-slate-25 dark:border-slate-700 text-black-900 dark:text-slate-300 row"
      >
        <div
          class="flex-grow-0 flex-shrink-0 flex-[25%] min-w-0 py-4 pr-6 pl-0"
        >
          <h4 class="block-title text-black-900 dark:text-slate-200">
            {{ $t('GENERAL_SETTINGS.FORM.EXTERNAL_LINK_WARNING.TITLE') }}
          </h4>
          <p>
            {{ $t('GENERAL_SETTINGS.FORM.EXTERNAL_LINK_WARNING.NOTE') }}
          </p>
        </div>
        <div class="p-4 flex-grow-0 flex-shrink-0 flex-[50%]">
          <label class="checkbox-wrapper">
            <input
              v-model="warnOnExternalLinks"
              class="checkbox"
              type="checkbox"
              @change="onExternalLinksCheckbox($event.target.checked)"
            />
            <span>Enable External Links Warning</span>
          </label>
        </div>
      </div>

      <div class="text-sm text-center p-4">
        <div>{{ `v${globalConfig.appVersion}` }}</div>
        <div v-if="hasAnUpdateAvailable && globalConfig.displayManifest">
          {{
            $t('GENERAL_SETTINGS.UPDATE_CHATWOOT', {
              latestChatwootVersion: latestChatwootVersion,
            })
          }}
        </div>
        <div class="build-id">
          <div>{{ `Build ${globalConfig.gitSha}` }}</div>
        </div>
      </div>

      <woot-submit-button
        v-if="hasEditPermission('Account settings')"
        :class="`button nice success button--fixed-top`"
        :button-text="$t('GENERAL_SETTINGS.SUBMIT')"
        :loading="isUpdating"
      />
    </form>

    <div v-if="false /* d99d */">
      <button
        class="button primary"
        style="margin-inline-end: 1rem"
        @click="downloadAllConversation"
      >
        {{ $t('GENERAL_SETTINGS.EXPORT_ALL_CONVERSATION') }}
      </button>
      <label
        v-if="
          downloadConversationInfo.status !== 'completed' &&
          downloadConversationInfo.message
        "
        style="display: inline; font-style: italic; font-size: 0.8rem"
      >
        {{ downloadConversationInfo.message }}
        <woot-button
          color-scheme="info"
          variant="link"
          icon="ion-android-refresh"
          @click="fetchExportStatus"
        />
      </label>
      <a
        v-else-if="
          downloadConversationInfo.status === 'completed' &&
          downloadConversationInfo.file
        "
        :href="downloadConversationInfo.file.url"
      >
        {{ downloadConversationInfo.file.name }}
      </a>
    </div>
    <woot-loading-state v-if="uiFlags.isFetchingItem" />
  </div>
</template>

<script>
import {
  required,
  minValue,
  maxValue,
  ipAddress,
} from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import configMixin from 'shared/mixins/configMixin';
import accountMixin from '../../../../mixins/account';
import ImageUploader from '../../../../components/widgets/forms/ImageUploader';
import { FEATURE_FLAGS } from '../../../../featureFlags';
import semver from 'semver';
import uiSettingsMixin from 'dashboard/mixins/uiSettings';
import hasPermissionMixin from 'dashboard/mixins/hasPermission';
import ConcurrentUsersAPI from 'dashboard/api/concurrentUsers';

// d99d The concurrent users cap has no unlimited state, so blank is invalid rather than meaning
// "no limit". Rejects 0, negatives, decimals and anything non-numeric.
const isPositiveWholeNumber = value =>
  /^\d+$/.test(String(value ?? '').trim()) && Number(value) >= 1;

const CONCURRENT_USERS_POLL_INTERVAL = 15000; // d99d

export default {
  components: { ImageUploader },
  mixins: [
    accountMixin,
    alertMixin,
    configMixin,
    uiSettingsMixin,
    hasPermissionMixin,
  ],
  data() {
    return {
      id: '',
      name: '',
      domain: '',
      supportEmail: '',
      features: {},
      autoResolveDuration: null,
      latestChatwootVersion: null,
      logoFile: '',
      logoUrl: '',
      showLogo: false,
      downloadConversationInfo: {},
      allowedIps: [], // d99d
      warnOnExternalLinks: false, // d99d
      concurrentUsersLimit: null, // d99d
      concurrentUsersActive: null, // d99d null until the live count has been fetched
      concurrentUsersPoll: null, // d99d
    };
  },
  // d99d a function so the concurrent users rule only applies while that section is shown -
  // accounts without the feature must still be able to save their general settings
  validations() {
    return {
      name: {
        required,
      },
      autoResolveDuration: {
        minValue: minValue(1),
        maxValue: maxValue(999),
      },
      allowedIps: {
        $each: {
          ipAddress,
        },
      },
      concurrentUsersLimit: this.showConcurrentUsersConfig
        ? { positiveWholeNumber: isPositiveWholeNumber }
        : {},
    };
  },
  computed: {
    ...mapGetters({
      globalConfig: 'globalConfig/get',
      getAccount: 'accounts/getAccount',
      uiFlags: 'accounts/getUIFlags',
      allConversations: 'getAllConversations',
      allConversationsWithoutPage: 'getAllConversationsExPage',
      accountId: 'getCurrentAccountId',
      isFeatureEnabledonAccount: 'accounts/isFeatureEnabledonAccount',
      accountUserFeatures: 'getCurrentFeatures', // d99d
    }),
    // d99d
    // Support email and allowed IPs are managed by the partner, not the account,
    // so they stay hidden for every Online99 platform account.
    online99PlatformsCanSeeSupportEmail() {
      return this.accountUserFeatures?.support_email !== false;
    },
    online99PlatformsCanSeeAllowedIps() {
      return this.accountUserFeatures?.allowed_ips !== false;
    },
    // .
    showAutoResolutionConfig() {
      return this.isFeatureEnabledonAccount(
        this.accountId,
        FEATURE_FLAGS.AUTO_RESOLVE_CONVERSATIONS
      );
    },
    hasAnUpdateAvailable() {
      if (!semver.valid(this.latestChatwootVersion)) {
        return false;
      }

      return semver.lt(
        this.globalConfig.appVersion,
        this.latestChatwootVersion
      );
    },
    isUpdating() {
      return this.uiFlags.isUpdating;
    },

    featureInboundEmailEnabled() {
      return !!this.features.inbound_emails;
    },

    featureCustomReplyDomainEnabled() {
      return (
        this.featureInboundEmailEnabled && !!this.features.custom_reply_domain
      );
    },

    featureCustomReplyEmailEnabled() {
      return (
        this.featureInboundEmailEnabled && !!this.features.custom_reply_email
      );
    },

    getAccountId() {
      return this.id.toString();
    },
    // d99d
    isAddAllowedIpAvailable() {
      return this.allowedIps.length < 5;
    },
    // The section exists only for accounts the feature was enabled on from super admin, and only
    // for users holding the dedicated Concurrent Users permission.
    showConcurrentUsersConfig() {
      return (
        this.isFeatureEnabledonAccount(
          this.accountId,
          FEATURE_FLAGS.CONCURRENT_USERS
        ) && this.hasReadPermission('Concurrent Users')
      );
    },
    canEditConcurrentUsersLimit() {
      return this.hasEditPermission('Concurrent Users');
    },
    // .
  },
  mounted() {
    if (!this.id) {
      // d99d, but why
      this.initializeAccount();
    }
    if (this.hasReadPermission('Account settings')) {
      this.fetchExportStatus(); // d99d
    }
    this.startConcurrentUsersPolling(); // d99d
  },
  beforeDestroy() {
    clearInterval(this.concurrentUsersPoll); // d99d
  },
  methods: {
    async initializeAccount() {
      try {
        const {
          name,
          locale,
          id,
          domain,
          support_email,
          features,
          auto_resolve_duration,
          latest_chatwoot_version: latestChatwootVersion,
          logo_url,
          allowed_ips,
          warn_on_external_links,
          concurrent_users_limit,
        } = this.getAccount(this.accountId);

        this.$root.$i18n.locale = locale;
        this.name = name;
        this.id = id;
        this.domain = domain;
        this.supportEmail = support_email;
        this.features = features;
        this.autoResolveDuration = auto_resolve_duration;
        this.latestChatwootVersion = latestChatwootVersion;
        this.logoUrl = logo_url;
        this.allowedIps = allowed_ips || [];
        this.warnOnExternalLinks = warn_on_external_links || false;
        this.concurrentUsersLimit = concurrent_users_limit ?? null; // d99d
        if (!this.allowedIps.length) this.allowedIps.push(undefined);
      } catch (error) {
        // Ignore error
      }
    },

    async updateAccount() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.showAlert(this.$t('GENERAL_SETTINGS.FORM.ERROR'));
        return;
      }
      try {
        const allowedIps = this.allowedIps.filter(
          x => !!x && x.trim().length > 0
        );
        const payload = {
          domain: this.domain,
          support_email: this.supportEmail,
          auto_resolve_duration: this.autoResolveDuration,
          logo: this.logoFile,
          warn_on_external_links: this.warnOnExternalLinks,
          allowed_ips: allowedIps.length ? allowedIps : null,
        };
        // d99d only sent by users allowed to change it - the API rejects it otherwise
        if (
          this.showConcurrentUsersConfig &&
          this.canEditConcurrentUsersLimit
        ) {
          payload.concurrent_users_limit = Number(this.concurrentUsersLimit);
        }
        await this.$store.dispatch('accounts/update', payload);
        this.logoFile = '';
        this.showAlert(this.$t('GENERAL_SETTINGS.UPDATE.SUCCESS'));
      } catch (error) {
        this.showAlert(this.$t('GENERAL_SETTINGS.UPDATE.ERROR'));
      }
    },
    // d99d
    handleImageUpload({ file, url }) {
      this.logoFile = file;
      this.logoUrl = url;
    },
    handleImageDelete() {
      this.logoFile = null; // explicit deletion
      this.logoUrl = '';
    },
    async downloadAllConversation() {
      try {
        await this.$store.dispatch('downloadAllConversations');
        this.downloadConversationInfo = {
          message: this.$t('GENERAL_SETTINGS.EXPORT_ALL_CONVERSATION_STARTED'),
        };
      } catch (error) {
        this.downloadConversationInfo = {};
        this.showAlert(
          error.message || this.$t('IMPORT_CONVERSATIONS.ERROR_MESSAGE')
        );
      }
    },
    async fetchExportStatus() {
      try {
        const { status, message, file } = await this.$store.dispatch(
          'statusOfLastDownloadAllConversations'
        );
        this.downloadConversationInfo = { status, message, file };
      } catch (error) {
        this.showAlert(
          error.message || this.$t('IMPORT_CONVERSATIONS.ERROR_MESSAGE')
        );
      }
    },

    // d99d The count is labelled "live", so it is refreshed while the page stays open rather than
    // frozen at load time.
    startConcurrentUsersPolling() {
      if (!this.showConcurrentUsersConfig) {
        return;
      }
      this.fetchConcurrentUsers();
      this.concurrentUsersPoll = setInterval(
        this.fetchConcurrentUsers,
        CONCURRENT_USERS_POLL_INTERVAL
      );
    },
    async fetchConcurrentUsers() {
      try {
        const { data } = await ConcurrentUsersAPI.get();
        this.concurrentUsersActive = data.count;
      } catch (error) {
        // leave the previous value alone, the next tick can pick it up
      }
    },
    addAllowedIp() {
      if (this.allowedIps.length < 5) {
        this.allowedIps.push(undefined);
      }
    },
    removeAllowedIp(index) {
      this.allowedIps.splice(index, 1);
    },
    // .
    onExternalLinksCheckbox(checked) {
      this.warnOnExternalLinks = checked;
    },
    updateDirectionView(locale) {
      const isRTLSupported = getLanguageDirection(locale);
      this.updateUISettings({
        rtl_view: isRTLSupported,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.checkbox-wrapper {
  display: flex !important;
  @apply mt-8 items-center gap-2;

  .checkbox {
    @apply m-0;
  }
}
// d99d
.error {
  @apply mt-2 bg-red-100 dark:bg-red-100 rounded-md text-red-800 dark:text-red-800 p-2.5 text-center;
}

// d99d the live concurrent user count that sits next to the limit label.
// ms-2 is a logical margin, so the gap lands on the correct side in Hebrew too.
.live-count {
  @apply inline-flex items-center gap-1 ms-2 font-medium text-green-600 dark:text-green-600;

  .live-count__dot {
    @apply w-2 h-2 rounded-full bg-green-500 flex-shrink-0;
  }
}
</style>
